import {useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LeadsContext } from "../Context/LeadsContext";
import { getImages } from "../Const";

const AutoComplete = ({openMobArrow, handleMobArrow = () => {}}) => {
    const { setActiveLeadID,setActiveTab,filteredLeads,searchText,setSearchText, getLeads } = useContext(LeadsContext);

    const [showLeads,setShowLeads] = useState(false);
 
    const handleChange = (e) => {
        setSearchText(e.target.value);
    };

    const carIdSearch =(id)=>{
        setActiveLeadID(id)
        setActiveTab(true);
    }

    const showLeadTimeout = () => {
        setShowLeads(true);
        setTimeout(function() {
            // setShowLeads(false);
        }, 5000);
    }

    useEffect(()=>{
        if(searchText) showLeadTimeout();
    },[searchText]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // Perform action on Enter key press
            console.log('Enter key pressed');

            if(searchText) getLeads();
        }
    };
    

    return (
        <>
            <div className="search-box position-relative ms-5" onMouseEnter={() => setShowLeads(true)} onMouseLeave={() => showLeadTimeout()}>
                <div>
                    <input type='text'
                        className='form-control'
                        placeholder='Search'
                        onChange={handleChange}
                        value={searchText}
                        onKeyDown={handleKeyPress} />                        
                    <span className='search-icon'><i className="fa-solid fa-magnifying-glass"></i></span>
                </div>
                <div
                    className={`cs-search-list ${searchText && showLeads ? "d-none d-lg-block" : "d-none"}`}
                    // style={{
                    //     display: searchText && showLeads ? "d-none d-lg-block" : "d-none"
                    // }}
                >
                    {filteredLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.filter((lead,index) => { return index >= 5 ? false : true; }).map((option, index) => (
                            <div key={index} style={{cursor:"pointer"}} onClick={()=>carIdSearch(option.lead_id)}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ? 
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> :""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.First_Name} {option.Last_Name}</div>
                                        <div className="pd-email">{option.Email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.First_Name} {option.Last_Name}</div>
                                        <div className="pd-email">{option.Email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div
                    className="cs-search-list d-lg-none"
                    style={{
                        display: searchText && showLeads ? "block" : "none"
                    }}
                >
                    {filteredLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.filter((lead,index) => { return index >= 5 ? false : true; }).map((option, index) => (
                            <div key={index} style={{cursor:"pointer"}} onClick={()=>{handleMobArrow(option); setShowLeads(false); setSearchText("")}}>
                                <div className="autocomplete-items d-flex align-items-center">
                                    {option?.Vehicle_Photos ? 
                                        <div className="cssl-img position-relative">
                                            <img src={option.Vehicle_Photos.split(',')[0].trim()} alt="" />
                                            {option.Vehicle_Photos?.length > 1 ? <div className='vi-count'>+{option.Vehicle_Photos?.split(",").length}</div> :""}
                                        </div> :
                                        <div className='pd-no-img position-relative no-photo-pos'>
                                            <img src={getImages("thumb-no-photo.png")} alt='thumb' />
                                        </div>
                                    }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.First_Name} {option.Last_Name}</div>
                                        <div className="pd-email">{option.Email}</div>
                                    </div>
                                    {/* }
                                    <div className="cssl-content">
                                        <div className="pd-sm-title">{option?.Vehicle_Year} {option?.Vehicle_Make}</div>
                                        <div className="pd-xs-title my-2">{option?.First_Name} {option.Last_Name}</div>
                                        <div className="pd-email">{option.Email}</div>
                                    </div> */}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

export default AutoComplete;
